import axios from 'axios';

const cfg = { withCredentials: true };

// ---------------- AUTH ----------------
export const commercialLogin = async (password, remember = false) => {
  const res = await axios.post('/api/commercial/login', { password, remember }, cfg);
  return res.data;
};

export const commercialLogout = async () => {
  const res = await axios.post('/api/commercial/logout', null, cfg);
  return res.data;
};

export const commercialMe = async () => {
  const res = await axios.get('/api/commercial/me', cfg);
  return res.data;
};

// ---------------- CATÁLOGO ----------------
export const getCommercialTalentos = async () => {
  const res = await axios.get('/api/commercial/talentos', cfg);
  return res.data;
};

export const createCommercialTalento = async (payload) => {
  const res = await axios.post('/api/commercial/talentos', payload, cfg);
  return res.data;
};

// ---------------- PROPUESTAS ----------------
export const listPropuestas = async (params = {}) => {
  const res = await axios.get('/api/commercial/propuestas', { ...cfg, params });
  return res.data;
};

export const getPropuesta = async (id) => {
  const res = await axios.get(`/api/commercial/propuestas/${id}`, cfg);
  return res.data;
};

export const createPropuesta = async (payload) => {
  const res = await axios.post('/api/commercial/propuestas', payload, cfg);
  return res.data;
};

export const updatePropuesta = async (id, payload) => {
  const res = await axios.put(`/api/commercial/propuestas/${id}`, payload, cfg);
  return res.data;
};

export const deletePropuesta = async (id) => {
  const res = await axios.delete(`/api/commercial/propuestas/${id}`, cfg);
  return res.data;
};
